/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { QueryProvider } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';

import { Pep } from './Pep';

export const PepDesktopContainer = (props) => {
  const store = useStore({ varnish: false });
  const { storeId, storeZip } = store || {};
  const defaultVariables = {
    storeId,
    zipCode: storeZip,
    skipInstallServices: false,
    skipSpecificationGroup: false
  };

  return (
    <QueryProvider
      {...props}
      cacheKey="pep-page"
      defaultVariables={defaultVariables}
    >
      <Pep />
    </QueryProvider>
  );
};

PepDesktopContainer.displayName = 'PepDesktopContainer';
